import React from 'react'
import { createUseStyles } from 'react-jss'

import BackgroundLines from './BackgroundLines'
import BackgroundBlur from './BackgroundBlur'

import { LG } from '../constants/mediaQueries'

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    color: '#fff',
    textAlign: 'center',
    transition: 'padding 0.3s ease',
    paddingTop: 52,
    paddingBottom: 52,
    transitionProperty: 'padding, justify-content',
    [LG]: {
      paddingTop: 69,
      paddingBottom: 69
    }
  }
})

export default function Layout({ children }) {
  const classes = useStyles()
  return (
    <>
      <div className={classes.root}>{children}</div>
      <BackgroundLines />
    </>
  )
}
